import { Component } from '@angular/core';
import { AssetService } from '../../Model/AssetModule/asset.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDropdownModule, NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { ComboService } from '../../Model/Combo/combo.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { group } from 'console';
import { StdioNull } from 'child_process';
import { UtilityService } from '../../Model/utility/utility.service';
import { SessionService } from '../../Util/Session/session.service';
import { CommonService } from '../../Model/Common/common.service';

@Component({
  selector: 'app-asset-master-form',
  standalone: true,
  imports: [NgSelectModule, CommonModule, FormsModule, NgbDropdownModule, NgbTooltipModule],
  templateUrl: './asset-master-form.component.html',
  styleUrl: './asset-master-form.component.scss'
})
export class AssetMasterFormComponent {
  isDisabled: boolean = false;
  user = [] as any
  AseetDetail = {
    SelectType: 'Insert',
    ESS_AssetMasterId: 0,
    ESS_AssetGroupMasterID: null,
    AssetMasterCode: null,
    AssetMasterName: null,
    Description: null,
    Image: null,
    ImageUrl: null as any
  }
  Branch = [] as any;
  Group = [] as any;


  constructor(
    private Asset: AssetService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private toast: ToastService,
    private router: Router,
    private combo: ComboService,
    private utility: UtilityService,
    private session: SessionService,
    private common: CommonService
  ) {
    this.route.params.subscribe(params => this.AseetDetail.ESS_AssetMasterId = parseInt(params['id']));
    this.user = this.session.GetUserDetails();
  }

  ngOnInit(): void {
    this.ComboLoad('AssetGroupMaster');
    if (this.AseetDetail.ESS_AssetMasterId > 0) {
      this.LoadAssetMaster();
    }
  }


  Validate(form: any) {
    if (form.valid) {
      if (this.AseetDetail.AssetMasterName != null && this.AseetDetail.AssetMasterCode != null && this.AseetDetail.Description != null) {
        this.AssetMasterInsertUpdate();
      }
    }
    else {
      form.submitted = true;
    }
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.combo.ComboLoad({ 'Combotype': Combotype }).subscribe({
      next: (response) => {
        if (Combotype == 'AssetGroupMaster') {
          this.Group = response.ComboLoad;
          console.log(response);

        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  LoadAssetMaster() {
    this.isDisabled = true;
    this.Asset.LoadAssetMaster({ SelectType: 1, ESS_AssetMasterId: this.AseetDetail.ESS_AssetMasterId }).subscribe({
      next: (response) => {
        this.AseetDetail = response[0];
        this.AseetDetail.ImageUrl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + 'AssetMasterAttachment' + '/' + response[0].Image;
        this.AseetDetail.Image = response[0].Image;
        this.AseetDetail.SelectType = 'update';
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  AssetMasterInsertUpdate() {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to save?';
    modalRef.result.then(result => {
      if (result) {
        this.isDisabled = true;
        this.Asset.InsertUpdateAssetMaster(this.AseetDetail).subscribe({
          next: (response) => {
            if (response.Error_Code == '01') {
              this.router.navigate(['/Asset/assetmaster/']);
              this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
            } else {
              this.toast.show({ message: response.Error_Message, type: toastTypeEnum.danger });
            }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    });
  }
  upload(event: any, Folder: any) {
    try {
      this.isDisabled = true;
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.utility.Upload({ 'DomainName': this.user.Domain, 'folder': Folder, 'CompanyCode': this.user.CompanyCode, 'FileBase64': reader.result }).subscribe((response: any) => {
          if (response.FileName != "") {
            this.AseetDetail.Image = response.FileName;
            this.AseetDetail.ImageUrl = response.Url;
          } else {
            this.toast.show({ message: 'Image not uploaded', type: toastTypeEnum.danger });
          }
          this.isDisabled = false;
        }, (error) => {
          this.isDisabled = false;
        });
      };
    } catch (e) { }
  }
  OnChange() {

    console.log(this.AseetDetail.ESS_AssetGroupMasterID);
  }



}
